import { UserCompanyModule } from './userCompanyModule.model';

export class UserCompanyModel {

    uid: string;
    parametrizationUid: string;
    parametrizationName: string;
    companyName: string;
    vatNumber: string;
    sepaId: string;
    logo: File;
    qrstring: string;

    accountLength: number;
    lopd: string;

    lastPreinvoice: string;
    lastDeliverynote: string;

    certPassword: string;

    username: string;
    statusOk: boolean;
    password: string;
    company: string;
    url: string;

    invoiceFooter: string;

    modulos: boolean;
    contabilidad: boolean;
    alquilado: boolean;
    modelo115: boolean;
    empleados: boolean;
    modelo111: boolean;
    retenciones: boolean;
    modelo130: boolean;
    modelo131: boolean;
    modelo420: boolean;
    modelo421: boolean;
    modelo308: boolean;
    modelo347: boolean;
    modelo415: boolean;
    modelo200: boolean;
    modelo202: boolean;
    modelo123: boolean;
    sii: boolean;
    accountingConvfact: boolean;

    facturasRetencion: boolean;
    otrosRetencion: boolean;
    modelo300_399: boolean;
    modelo190: boolean;
    modelo180: boolean;
    modelo184: boolean;
    modelo193: boolean;
    modelo425: boolean;
    modelo415_347: boolean;
    modelo100: boolean;

    modelo390: boolean;

    aplicacionIgic: boolean;
    franquiciaFiscal: boolean;

    useContanet: boolean;

    numDecimals: number;

    residenceType: string;

    modules: [UserCompanyModule];

    registroDevolucionMensual: boolean;
    operacionesIntraComunitarias: boolean;

    situacionConcursoAcreedores: boolean;
    fechaInicioConcursoAcreedores: Date;
    tipoConcursoAcreedores: string;

    modelo303M: boolean;
    modelo303C: boolean;

    modelo308M: boolean;
    modelo308C: boolean;
    modelo309M: boolean;
    modelo309C: boolean;
    modelo322: boolean;
    modelo210: boolean;

    cuotaIntegra: number;
    fechaInicioPeriodoImpositivo: Date;

    isSalesInvoice: boolean;
    isServiceInvoice: boolean;

    autoProcesarFacturas: boolean;
    autoProcesarNominas: boolean;

    entidadSinAnimoLucro: boolean;

    constructor() {
    }
}
